import * as React from 'react';
import { Link } from 'react-router-dom';

import { Workspace, WorkspaceActiveStatus } from 'generated/fetch';

import { isUsingInitialCredits } from 'app/utils/workspace-utils';

import { WorkspaceInfoField } from './workspace-info-field';

interface Props {
  workspace: Workspace;
  activeStatus: WorkspaceActiveStatus;
}
export const BasicInformation = ({ workspace, activeStatus }: Props) => {
  return (
    <>
      <h3>Basic Information</h3>
      <div className='basic-info' style={{ marginTop: '1.5rem' }}>
        <WorkspaceInfoField labelText='Active Status'>
          {activeStatus}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Billing Account Type'>
          {isUsingInitialCredits(workspace)
            ? `Initial credits (${workspace.creatorUser.userName})`
            : 'User provided'}
        </WorkspaceInfoField>
        {isUsingInitialCredits(workspace) && (
          <WorkspaceInfoField labelText='Initial Credits Billing Status'>
            {workspace.initialCredits?.exhausted
              ? 'Exhausted'
              : 'Not Exhausted'}
            ,{' '}
            {workspace.initialCredits?.expirationEpochMillis <= Date.now()
              ? 'Expired'
              : 'Not Expired'}
          </WorkspaceInfoField>
        )}
        <WorkspaceInfoField labelText='Workspace Name'>
          {workspace.name}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Terra Name'>
          {workspace.terraName}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Workspace Namespace'>
          {workspace.namespace}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Access Tier'>
          {workspace.accessTierShortName?.toUpperCase()}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Google Project Id'>
          {workspace.googleProject}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Creation Time'>
          {new Date(workspace.creationTime).toDateString()}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Last Modified Time'>
          {new Date(workspace.lastModifiedTime).toDateString()}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Pod ID'>
          {workspace.recoveryPodId || 'No pod attached'}
        </WorkspaceInfoField>
        <WorkspaceInfoField labelText='Audit'>
          {
            <Link to={`/admin/workspace-audit/${workspace.namespace}`}>
              Audit History
            </Link>
          }
        </WorkspaceInfoField>
      </div>
    </>
  );
};
